// Early access (temporary, until the full public release): whether the tabletop is locked for this account, and the
// one key that unlocks it. The server decides; a read that fails lets the page go on, and the server's refusal of the
// next call (403 `locked`) brings the screen back.
import { authFetch } from './session';

export interface AccessState { gate: boolean; unlocked: boolean }

export async function fetchAccess(fetchImpl: typeof fetch = fetch): Promise<AccessState> {
  try {
    const res = await authFetch('/api/access', { headers: { Accept: 'application/json' } }, fetchImpl);
    if (!res.ok) return { gate: false, unlocked: true };
    const b = (await res.json()) as Partial<AccessState> | null;
    return { gate: b?.gate === true, unlocked: b?.unlocked !== false };
  } catch {
    return { gate: false, unlocked: true };
  }
}

export type UnlockResult = { ok: true } | { ok: false; reason: string };

export async function unlockAccess(key: string, fetchImpl: typeof fetch = fetch): Promise<UnlockResult> {
  try {
    const res = await authFetch('/api/access/unlock', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ key }),
    }, fetchImpl);
    if (res.ok) return { ok: true };
    const b = (await res.json().catch(() => null)) as { reason?: unknown } | null;
    return { ok: false, reason: typeof b?.reason === 'string' ? b.reason : 'The key could not be checked right now. Try again.' };
  } catch {
    return { ok: false, reason: 'The key could not be checked right now. Try again.' };
  }
}
